import dayjs from 'dayjs';

import Link from 'next/link';
import Container from 'components/container/container';

import { LIBUM_URL } from 'shared/constants/globals';
import {
  ContentHeadline,
  ContentList,
  ContentListItem,
  ContentListItemMeta,
  ContentMain,
  ContentPanel,
} from 'shared/styles/components';

import { BLOG_ITEMS } from 'shared/data/blogs';

export default function Blog() {
  const title = 'Blog | Libum';
  const description = `Learn about Libum's product updates, insights, credit union trends, and much more.`;
  const keywords = 'Libum,Libum blog,Libum updates,Libum thoughts,Libum team updates';
  const url = `${LIBUM_URL}/blog`;

  return (
    <Container title={title} description={description} keywords={keywords} url={url} socialCard="blog">
      <div style={{ width: '100%' }}>
        <ContentPanel>
          <ContentHeadline>
            <h1>Blog</h1>
            <p>Latest updates, thoughts, and more from the Libum team.</p>
          </ContentHeadline>
        </ContentPanel>
        <ContentPanel>
          <ContentMain>
            <ContentList>
              {...BLOG_ITEMS.sort((a, b) => dayjs(b.date).unix() - dayjs(a.date).unix()).map((blog) => (
                <ContentListItem key={blog.id}>
                  <h3>
                    <Link href={`/blog/` + blog.id}>{blog.title}</Link>
                  </h3>
                  <p>{blog.description}</p>
                  <ContentListItemMeta>
                    <Link href={blog.authorLink}>{blog.authorLabel}</Link>
                    <span>{dayjs(blog.date).format('MMMM DD, YYYY')}</span>
                  </ContentListItemMeta>
                </ContentListItem>
              ))}
            </ContentList>
          </ContentMain>
        </ContentPanel>
      </div>
    </Container>
  );
}
